import { Box, styled, Tab, tabClasses, Tabs } from '@mui/material';
import { useState } from 'react';
import { LogTabs } from '../types/log-tabs';

type LogsTabsProps = {
  tabs: LogTabs[];
};

export const LogsTabs = ({ tabs }: LogsTabsProps) => {
  const [selectedTabId, setSelectedTabId] = useState(tabs[0]?.id);

  const selectedTab = tabs.find((tab) => tab.id === selectedTabId);

  return (
    <StyledBox>
      <Tabs value={selectedTabId} onChange={(_, tabId) => setSelectedTabId(tabId)}>
        {tabs.map((tab) => (
          <StyledTab key={tab.id} value={tab.id} label={tab.tabLabel} />
        ))}
      </Tabs>
      {selectedTab?.element ? selectedTab.element : null}
    </StyledBox>
  );
};

const StyledTab = styled(Tab)(({ theme }) => ({
  borderRadius: '0px',
  color: theme.palette.lwPrimaryAccentDark[60],
  backgroundColor: theme.palette.lwWhite[100],
  borderBottom: '1px solid transparent',

  [`&:hover, &.${tabClasses.selected}`]: {
    color: theme.palette.lwPrimaryAccentLight[100],
    backgroundColor: 'transparent',
    borderBottom: `1px solid ${theme.palette.lwPrimaryAccentDark[100]}`,
  },
}));

const StyledBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(4),
}));
